module.exports = __webpack_public_path__ + "static/media/dm.478c0a5f.svg";